<template>
  <BasketComponent />
</template>

<script>
// @ is an alias to /src
import BasketComponent from "@/components/Basket/Basket.vue";

export default {
  name: "Product",
  components: {
    BasketComponent
  }
};
</script>
